import { AgentSkillReferenceSchema, uiToolPartSchema } from '@aline/common';

export function getSkillLoadVersionIds(parts: readonly unknown[]) {
  return new Set(getSkillLoads(parts).map(load => load.versionId));
}

/** The skill version each finished `loadSkill` part loaded, once per version, in load order. */
export function getSkillLoads(parts: readonly unknown[]) {
  const loads = parts.flatMap(raw => {
    const parsed = uiToolPartSchema.safeParse(raw);
    if (
      !parsed.success ||
      parsed.data.type !== 'tool-loadSkill' ||
      parsed.data.state !== 'output-available'
    )
      return [];
    const reference = AgentSkillReferenceSchema.safeParse(parsed.data.input);
    return reference.success ? [reference.data] : [];
  });
  return [...new Map(loads.map(load => [load.versionId, load])).values()];
}
